import React from 'react';
import { useDispatch } from 'reducers';
import { useI18n } from 'components/I18n';
import * as campaignActions from 'actions/campaign';
import { TGetOfferPriceMutation } from 'queries/getOfferPrice.generated';

type TData = TGetOfferPriceMutation['discount'];

type TUseRefund = {
  loading: boolean;
  error: string | null;
  data: TData;
};

export function useRefund(packageId: string, originalOfferId?: string): TUseRefund {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(!!originalOfferId);
  const [error, setError] = React.useState(null);
  const [data, setData] = React.useState<TData>({});

  React.useEffect(() => {
    if (!originalOfferId || !packageId) {
      setData({});
      setError(null);
      return () => {};
    }

    let cancelled = false;

    setLoading(true);
    setError(null);
    setData({});

    dispatch(campaignActions.getRefund(packageId, originalOfferId)).then(
      (result) => {
        if (cancelled) {
          return;
        }

        if (result.valid) {
          setData(result.discount);
        } else {
          setError(i18n.formatText(result.errorId));
        }
        setLoading(false);
      },
      () => {
        setLoading(false);

        if (cancelled) {
          return;
        }

        setError(i18n.formatText('failedMessage'));
      },
    );

    return () => {
      cancelled = true;
    };
  }, [packageId, originalOfferId]);

  return {
    loading,
    error,
    data,
  };
}
